export default "__VITE_ASSET__CaD3EGcX__"